import { useContext } from 'react';

import PersonContext from '@/pages/Person/PersonContext';
import { PersonStaffRelationshipType } from '@/types/personStaffRelationship';
import formatStaffName from '@/utils/formatStaffName';

// Shared "current vs. selected" logic behind Booking's ConfirmationModal and
// AddToGroupModal's provider picker -- both let staff optionally set a
// PersonStaffRelationship (e.g. Primary Counselor) for a relationship_type
// while doing something else (booking an appointment / adding to a group).
// selectedProviderId is always a Staff uuid (Staff.id), never a healthie_id.
export const usePrimaryProviderAssignment = (
  relationshipType: PersonStaffRelationshipType | null | undefined,
  selectedProviderId: string
) => {
  const { person } = useContext(PersonContext);

  const currentRelationships = person.staff_relationships.filter(
    (relationship) =>
      !!relationshipType && relationship.relationship_type?.slug === relationshipType.slug
  );
  const isSelectedProviderCurrent = currentRelationships.some(
    (relationship) => relationship.staff?.id === selectedProviderId
  );
  const tooManyPrimaries = currentRelationships.length > 1 && !isSelectedProviderCurrent;
  const canSetPrimary = !!selectedProviderId && !isSelectedProviderCurrent && !tooManyPrimaries;
  const currentStaffNames = currentRelationships.length
    ? currentRelationships
        .filter((relationship) => !!relationship.staff)
        .map((relationship) => formatStaffName({ staff: relationship.staff! }))
        .join(', ')
    : 'None';

  return {
    canSetPrimary,
    currentRelationships,
    currentStaffNames,
    isSelectedProviderCurrent,
    tooManyPrimaries
  };
};

export default usePrimaryProviderAssignment;
